var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('issue',{attrs:{"issue":_vm.issue,"issue-fields":_vm.fields,"issue-edit-fields":_vm.fields,"is-saving":_vm.isSaving,"save":_vm.save,"back-button":"","can-edit":"","is-editing":""},on:{"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }